/* ============================================================
   Bisou Rivage — Framed Wall Planner (page /pages/framed-wall-planner)
   Adapté de la maquette composer-mockup v5.1 → branché Shopify :
   - Catalogue : window.BRPlanner.products (généré en Liquid, variantes réelles)
   - Prix : variantes réelles (cents) · Panier : /cart/add.js
   - Wishlist : window.BisouWishlist (br_wishlist_v1) — fallback interne
   - Remises paliers : codes promo optionnels (cfg.codes) appliqués via /discount/
   - Dimensions encadrées réelles : A4 30×40 · A3 40×50 · A2 50×70 cm
   - Accroche standard 160 cm. Tout encadré (variantes « sans cadre » exclues).
   Entrées : ?id={handle} (page produit) · ?vide (bandeau)
   ============================================================ */
(function () {
  'use strict';

  var BOOT = window.BRPlanner || {};
  var LANG = BOOT.lang || {};
  function t(key, fallback) {
    var v = LANG[key];
    return (typeof v === 'string' && v) ? v : fallback;
  }
  function tfill(key, fallback, vars) {
    var s = t(key, fallback);
    for (var k in vars) {
      if (Object.prototype.hasOwnProperty.call(vars, k)) {
        s = s.split('{' + k + '}').join(vars[k]);
      }
    }
    return s;
  }
  var CFG = {
    maxFrames: 5,
    dims: { A4: [30, 40], A3: [40, 50], A2: [50, 70] }, // encadré réel (cm), portrait [l,h]
    formats: ['A2', 'A3', 'A4'],
    frames: [
      { key: 'noir',    label: t('frame_noir', 'Noir'),       sw: '#222222' },
      { key: 'blanc',   label: t('frame_blanc', 'Blanc'),     sw: '#ffffff' },
      { key: 'chene',   label: t('frame_chene', 'Chêne'),     sw: '#b8956a' },
      { key: 'bouleau', label: t('frame_bouleau', 'Bouleau'), sw: '#d4c4a8' }
    ],
    satLevels: [0, 9, 17, 25, 33],
    hangLine: 160, drillDrop: 3, gap: 7, margin: 10,
    /* Calibrage des mockups. Mesuré le 02/09/2026 sur six produits, trois
       artistes et deux résolutions de toile (4000x3200 et 2500x2000) : les
       mockups sortent d'un pipeline régulier, le cadre occupe TOUJOURS la même
       fraction de la toile — à 0,3 % près — et il y est centré.
       Valeurs en PORTRAIT [largeur, hauteur] ; le paysage est la transposée.
       Sans ce calibrage, `object-fit: contain` laissait le cadre flotter dans sa
       boîte : A4 −21 %, A3 −15 %, A2 −13 %, et pas du même montant d'un format
       à l'autre. Le mur vu n'avait donc ni les bonnes tailles relatives ni le
       bon écart — alors que le plan d'accrochage, lui, est calculé sur les
       boîtes et reste juste. Voir mockupFill(). */
    mockup: { A4: [0.7801, 0.8213], A3: [0.8386, 0.8388], A2: [0.8627, 0.9565] },
    cartUrl: '/cart',
    defaultWall: { w: 200, h: 250 }
  };
  /* name = libellé affiché, traduit. slug = donnée de commande, jamais traduite :
     la propriété de ligne de panier ne doit pas changer avec la langue du visiteur. */
  var DISPO = [
    { n: 2, label: '2 cadres (diptyque)', name: t('compo_name_2', 'diptyque'), slug: 'diptyque' },
    { n: 3, label: '3 cadres (triptyque)', name: t('compo_name_3', 'triptyque'), slug: 'triptyque' },
    { n: 4, label: '4 cadres (tétraptyque)', name: t('compo_name_4', 'tétraptyque'), slug: 'tétraptyque' },
    { n: 5, label: '5 cadres (pentaptyque)', name: t('compo_name_5', 'pentaptyque'), slug: 'pentaptyque' }
  ];
  var FRAME_KEYS = CFG.frames.map(function (f) { return f.key; });
  var GHOST = [40, 50];

  /* ---------- catalogue depuis les produits Liquid ---------- */
  function norm(s) {
    s = (s || '').toLowerCase().normalize('NFD');
    var out = '';
    for (var i = 0; i < s.length; i++) { var c = s.charCodeAt(i); if (c < 768 || c > 879) out += s.charAt(i); }
    return out;
  }
  function frameOf(v) {
    v = norm(v);
    if (/sans/.test(v)) return 'sans';
    if (/noir/.test(v)) return 'noir';
    if (/blanc/.test(v)) return 'blanc';
    if (/chene/.test(v)) return 'chene';
    if (/bouleau/.test(v)) return 'bouleau';
    return null;
  }
  function fmtOf(v) {
    v = norm(v);
    if (/a2/.test(v)) return 'A2';
    if (/a3/.test(v)) return 'A3';
    if (/a4/.test(v)) return 'A4';
    return null;
  }
  var CAT = [];
  var catById = {};
  (BOOT.products || []).forEach(function (p) {
    var map = {}; // fmt -> frame -> {vid, price(cents), img, av}
    (p.vars || []).forEach(function (v) {
      var opts = [v.o1, v.o2, v.o3];
      var fr = null, fm = null;
      opts.forEach(function (o) {
        if (!fr) fr = frameOf(o);
        if (!fm) fm = fmtOf(o);
      });
      if (!fr || !fm || fr === 'sans') return;       // tout encadré
      if (!map[fm]) map[fm] = {};
      map[fm][fr] = { vid: v.id, price: v.p, img: v.img || p.thumb, av: v.av };
    });
    var fmts = CFG.formats.filter(function (k) { return map[k]; });
    if (!fmts.length) return;                         // produit sans variantes encadrées
    var cols = (p.cols || []).slice();
    var filterMap = (BOOT.cfg && BOOT.cfg.filters) || {};
    Object.keys(filterMap).forEach(function (handle) {
      if (handle !== '_all' && filterMap[handle].indexOf(p.h) > -1 && cols.indexOf(handle) < 0) cols.push(handle);
    });
    var tags = p.tags || [];
    var item = {
      id: p.h, title: p.t, url: p.url, vendor: p.vendor || '', tags: tags,
      /* Le Liquid résout l'édition (métachamp custom.br_edition_type, puis balise
         edition-ouverte, puis balise historique open) et envoie un booléen. Le test
         par sous-chaîne sur les balises ne sert plus que de repli. */
      open: (typeof p.open === 'boolean') ? p.open : tags.some(function (tag) { return norm(tag).indexOf('open') > -1; }),
      orient: p.orient, thumb: p.thumb, cols: cols, map: map, fmts: fmts,
      /* L'artiste vient du métaobjet `custom.artiste_reference`, résolu en
         Liquid. `product.vendor` vaut « Bisou Rivage » sur tous les tirages :
         le filtre « artiste » interrogeait donc une colonne constante. */
      artist: p.art || '', artistPic: p.apic || ''
    };
    item.vendor = item.artist || item.vendor;
    CAT.push(item); catById[p.h] = item;
  });

  /* ---------- wishlist globale (ou fallback même clé) ---------- */
  var WL = window.BisouWishlist || (function () {
    var KEY = 'br_wishlist_v1';
    function read() { try { var d = JSON.parse(localStorage.getItem(KEY)); return d && Array.isArray(d.items) ? d.items : []; } catch (e) { return []; } }
    function write(items) { try { localStorage.setItem(KEY, JSON.stringify({ v: 1, items: items })); } catch (e) {} }
    return {
      read: read,
      has: function (h) { return read().some(function (i) { return i.h === h; }); },
      toggle: function (d) {
        var items = read();
        if (items.some(function (i) { return i.h === d.h; })) { write(items.filter(function (i) { return i.h !== d.h; })); return false; }
        items.push(d); write(items); return true;
      }
    };
  })();

  /* ---------- état ---------- */
  var uidSeq = 1;
  var state = {
    frames: [],                 // {uid, id(handle), fmt, frame, x, y}
    region: { w: 160, h: 110 },
    scale: 'auto',
    wall: { w: CFG.defaultWall.w, h: CFG.defaultWall.h },
    wallColor: { h: 35, s: 0, hex: null },
    sel: null,
    targetCount: 3,
    previewMode: 'normal',
    rotated: false,
    largeZoom: 1.8,
    fsRestoreScale: null,
    ghosts: [],
    gap: CFG.gap,
    align: 'center',
    hang: CFG.hangLine,
    wallConfigured: false,
    tab: 'limited', filter: 'all', collection: 'all', artist: 'all',
    colsD: 4, colsM: 2,
    pickerTarget: null,
    pickerCols: 2,
    pickerFilter: 'all', pickerEdition: 'all', pickerCollection: 'all', pickerArtist: 'all'
  };
  var LS = 'br_planner_v1';
  function save() {
    try {
      localStorage.setItem(LS, JSON.stringify({
        frames: state.frames, scale: state.fsRestoreScale || state.scale, wall: state.wall,
        wallColor: state.wallColor, targetCount: state.targetCount, gap: state.gap,
        align: state.align, hang: state.hang,
        wallConfigured: state.wallConfigured,
        colsD: state.colsD, colsM: state.colsM
      }));
    } catch (e) {}
  }
  function load() {
    try {
      var d = JSON.parse(localStorage.getItem(LS)); if (!d) return false;
      if (Array.isArray(d.frames)) {
        state.frames = d.frames.filter(function (f) { return catById[f.id]; }).slice(0, CFG.maxFrames);
        state.frames.forEach(function (f) { if (FRAME_KEYS.indexOf(f.frame) < 0) f.frame = 'noir'; });
      }
      uidSeq = 1; state.frames.forEach(function (f) { f.uid = uidSeq++; });
      state.scale = 'auto';
      if (d.wall) { state.wall.w = d.wall.w || 200; state.wall.h = d.wall.h || 250; }
      if (d.wallColor) state.wallColor = d.wallColor;
      if (d.gap) state.gap = Math.max(2, Math.min(25, d.gap));
      if (d.align === 'top' || d.align === 'center' || d.align === 'bottom') state.align = d.align;
      if (d.hang) state.hang = Math.max(120, Math.min(200, d.hang));
      state.wallConfigured = !!d.wallConfigured;
      if (d.targetCount) state.targetCount = Math.max(2, Math.min(CFG.maxFrames, d.targetCount));
      else state.targetCount = Math.max(2, state.frames.length);
      if (d.colsD) state.colsD = d.colsD; if (d.colsM) state.colsM = d.colsM;
      return true;
    } catch (e) { return false; }
  }

  /* ---------- helpers ---------- */
  var root = document.getElementById('BRPlanner');
  if (!root || !CAT.length) return;
  function $(s) { return root.querySelector(s); }
  function $$(s) { return root.querySelectorAll(s); }
  function el(t, c) { var e = document.createElement(t); if (c) e.className = c; return e; }
  function dimsCm(fmt, orient) { var b = CFG.dims[fmt]; return orient === 'h' ? [b[1], b[0]] : [b[0], b[1]]; }
  /* Fraction de la toile du mockup réellement occupée par le cadre. Le mockup
     paysage est le portrait pivoté : on transpose. Un format inconnu rend
     [1, 1], ce qui redonne exactement l'ancien comportement. */
  function mockupFill(fmt, orient) {
    var m = CFG.mockup[fmt];
    if (!m) return [1, 1];
    return orient === 'h' ? [m[1], m[0]] : [m[0], m[1]];
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function entry(f) { var c = catById[f.id]; return (c.map[f.fmt] || {})[f.frame] || null; }
  function priceOf(f) { var e = entry(f); return e ? e.price : 0; }
  function imgOf(f) { var e = entry(f); return e ? e.img : catById[f.id].thumb; }
  function frameAvail(id, fmt) {
    var c = catById[id]; var m = c.map[fmt] || c.map[c.fmts[0]];
    return FRAME_KEYS.filter(function (k) { return m && m[k]; });
  }
  function fmtsAvail(id) { return catById[id].fmts; }
  function currentGap() { return state.gap || CFG.gap; }
  function onWall(id) { return state.frames.some(function (f) { return f.id === id; }); }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: cur, maximumFractionDigits: (cents % 100 ? 2 : 0) }).format(cents / 100); }
    catch (e) { return tfill('price_fallback', '{amount} €', { amount: (cents / 100).toFixed(0) }); }
  }
  function imgUrl(src, w) { if (!src) return ''; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function hslToHex(h, s, l) {
    s /= 100; l /= 100;
    var k = function (n) { return (n + h / 30) % 12; }, a = s * Math.min(l, 1 - l);
    var f = function (n) { return l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1))); };
    return '#' + [f(0), f(8), f(4)].map(function (x) { return Math.round(x * 255).toString(16).padStart(2, '0'); }).join('');
  }
  function wallHex() {
    if (state.wallColor.hex && /^#[0-9a-f]{6}$/i.test(state.wallColor.hex)) return state.wallColor.hex;
    var sat = CFG.satLevels[state.wallColor.s] || 0;
    if (!sat) return '#ffffff';
    return hslToHex(state.wallColor.h, sat, 96 - state.wallColor.s * 3.2);
  }
  function matchFormat(id, orient, targetH) {
    var best = null, bd = 1e9;
    fmtsAvail(id).forEach(function (k) {
      var h = dimsCm(k, orient)[1], d = Math.abs(h - targetH);
      if (d < bd) { bd = d; best = k; }
    });
    return best || fmtsAvail(id)[0];
  }
  function compoName() {
    var n = Math.max(state.frames.length, state.targetCount);
    if (!n) return root.dataset.titleEmpty || t('title_empty', 'Composer votre mur');
    if (n === 1) return t('compo_title_one', 'Votre tirage');
    for (var i = 0; i < DISPO.length; i++) if (DISPO[i].n === n) return tfill('compo_title', 'Votre {name}', { name: DISPO[i].name });
    return t('compo_title_generic', 'Votre composition');
  }
  /* Nom de composition destiné à la propriété de ligne de panier. Il reprend au mot
     près ce que produisait compoName().replace('Votre ', '') avant la traduction :
     diptyque / triptyque / tétraptyque / pentaptyque, tirage, composition. */
  function compoSlug() {
    var n = Math.max(state.frames.length, state.targetCount);
    if (n === 1) return 'tirage';
    for (var i = 0; i < DISPO.length; i++) if (DISPO[i].n === n) return DISPO[i].slug;
    return 'composition';
  }
  /* ---------- crans de lot ----------
     Les codes promo ont disparu. À leur place, deux remises AUTOMATIQUES créées
     dans l'admin Shopify : elles s'appliquent seules, se voient dans le panier,
     et valent quel que soit le chemin d'achat — y compris pour qui n'ouvre
     jamais le composeur.
     `on` reste faux tant que le réglage de thème n'est pas coché. Tant qu'il
     l'est, la page n'annonce AUCUN avantage : c'est la garde qui manquait quand
     les champs code portaient les libellés « -5% », ce qui faisait afficher une
     remise que Shopify n'appliquait jamais. */
  var TIERS = (function () {
    var cfg = (BOOT.cfg && BOOT.cfg.tiers) || {};
    var seen = {}, out = [];
    (cfg.steps || []).forEach(function (s) {
      var q = parseInt(s && s.qty, 10);
      if (!(q >= 2) || seen[q]) return;
      seen[q] = 1;
      out.push({ qty: q, kind: s.kind || 'service', pct: parseInt(s.pct, 10) || 0 });
    });
    out.sort(function (a, b) { return a.qty - b.qty; });
    return { on: !!cfg.on, steps: out };
  })();

  function tierLabel(s) {
    if (!s) return '';
    if (s.kind === 'shipping') return t('tier_shipping', 'Livraison offerte');
    if (s.kind === 'discount') return tfill('tier_discount', 'Le {n}ᵉ cadre à −{pct} %', { n: s.qty, pct: s.pct });
    return t('tier_service', 'Plan d’accrochage et gabarits offerts');
  }

  /* Le cran atteint (le plus haut), le cran suivant, et l'économie en centimes.
     Le cran « discount » reproduit ce que fait Shopify sur une remise « Achetez
     X obtenez Y » : la réduction tombe sur le tirage éligible LE MOINS CHER, pas
     sur le dernier posé. Approximation assumée : si le panier contient déjà
     d'autres tirages, Shopify calculera sur l'ensemble — le panier, lui, dira
     toujours la vérité. */
  function tierState() {
    var n = state.frames.length;
    var st = { on: TIERS.on, n: n, reached: null, next: null, save: 0 };
    if (!TIERS.on || !TIERS.steps.length) return st;
    for (var i = 0; i < TIERS.steps.length; i++) {
      var s = TIERS.steps[i];
      if (n >= s.qty) st.reached = s;
      else if (!st.next) st.next = s;
    }
    if (st.reached && st.reached.kind === 'discount' && st.reached.pct > 0) {
      var prices = [];
      state.frames.forEach(function (f) { var p = priceOf(f); if (p > 0) prices.push(p); });
      if (prices.length) {
        prices.sort(function (a, b) { return a - b; });
        st.save = Math.round(prices[0] * st.reached.pct / 100);
      }
    }
    return st;
  }

  /* ---------- échelle ---------- */
  var PXCM = 1;
  function regionDims() { return state.scale === 'real' ? [state.wall.w, state.wall.h] : [state.region.w, state.region.h]; }
  function fit() {
    var stage = $('#brpStage'), viewport = $('#brpViewport'), shell = $('#brpCanvasShell'), canvas = $('#brpCanvas');
    var d = regionDims(), W = d[0], H = d[1];
    var fs = root.classList.contains('br-fs');
    var mobile = window.innerWidth < 900;
    var displayW = state.rotated ? H : W, displayH = state.rotated ? W : H;
    var availW = (viewport.clientWidth || stage.clientWidth) - (fs ? 20 : 0);
    if (mobile && state.previewMode === 'large' && !fs) availW *= state.largeZoom;
    /* En mode « un seul écran », la scène occupe la hauteur que le flex lui
       laisse : on la mesure au lieu de prendre 58 % de la fenêtre. Le repli
       garde l'ancien calcul tant que la mise en page n'est pas faite. */
    var app = root.classList.contains('brp-app');
    var availH;
    /* En plein écran du mode « un seul écran », la scène est une couche fixe
       avec ses propres marges : on mesure la place que le flex laisse au
       viewport au lieu de soustraire des constantes devinées. */
    if (fs) availH = (app && viewport.clientHeight) ? viewport.clientHeight - 6 : window.innerHeight - (mobile ? 68 : 38);
    else if (app) availH = Math.max(160, (viewport.clientHeight || Math.round(window.innerHeight * 0.5)) - 6);
    else availH = Math.max(400, window.innerHeight * 0.58);
    if (mobile && state.previewMode === 'large' && !fs && !app) availH = window.innerHeight;
    PXCM = Math.min(availW / displayW, availH / displayH);
    if (!isFinite(PXCM) || PXCM <= 0) PXCM = 1;
    canvas.style.width = Math.round(W * PXCM) + 'px';
    canvas.style.height = Math.round(H * PXCM) + 'px';
    shell.style.width = Math.round(displayW * PXCM) + 'px';
    shell.style.height = Math.round(displayH * PXCM) + 'px';
    canvas.style.transformOrigin = 'top left';
    canvas.style.transform = state.rotated
      ? 'translateX(' + Math.round(H * PXCM) + 'px) rotate(90deg)'
      : 'none';
    canvas.style.background = wallHex();
    canvas.classList.toggle('is-white', wallHex() === '#ffffff' && state.scale !== 'real');
  }
  function clampFrame(f) {
    var o = catById[f.id].orient, d = dimsCm(f.fmt, o), r = regionDims();
    f.x = Math.max(0, Math.min(f.x, r[0] - d[0]));
    f.y = Math.max(0, Math.min(f.y, r[1] - d[1]));
  }

  /* ---------- layout aligné ---------- */
  function sizes() { return state.frames.map(function (f) { return dimsCm(f.fmt, catById[f.id].orient); }); }
  function ghostRects() {
    return state.ghosts || [];
  }
  function layoutAuto() {
    var n = state.frames.length, gap = currentGap(), M = CFG.margin;
    var S = sizes();
    var pending = Math.max(0, state.targetCount - n);
    var ghostSize = n ? S[S.length - 1].slice() : GHOST.slice();
    var all = S.slice();
    for (var gi = 0; gi < pending; gi++) all.push(ghostSize.slice());
    if (!all.length) all.push(GHOST.slice());
    var totW = all.reduce(function (s, d) { return s + d[0]; }, 0) + gap * (all.length - 1);
    var totH = Math.max.apply(null, all.map(function (d) { return d[1]; }));
    /* L'alignement vertical : centré par défaut, ou tous les bords hauts sur la
       même ligne, ou tous les bords bas. C'est un choix de composition réel —
       une rangée alignée par le haut n'a pas le même caractère qu'une rangée
       centrée — et il vaut pour les places vides comme pour les cadres. */
    function alignY(h) {
      if (state.align === 'top') return M;
      if (state.align === 'bottom') return M + (totH - h);
      return M + (totH - h) / 2;
    }
    var x = M;
    state.frames.forEach(function (f, i) { f.x = x; f.y = alignY(S[i][1]); x += S[i][0] + gap; });
    state.ghosts = [];
    for (var j = 0; j < pending; j++) {
      state.ghosts.push({ x: x, y: alignY(ghostSize[1]), w: ghostSize[0], h: ghostSize[1] });
      x += ghostSize[0] + gap;
    }
    state.region = { w: totW + 2 * M, h: Math.max(totH, GHOST[1]) + 2 * M };
  }
  function layoutReal() {
    state.ghosts = [];
    var n = state.frames.length; if (!n) return;
    var S = sizes(), W = state.wall.w, H = state.wall.h, gap = currentGap();
    var hangTop = Math.max(0, H - (state.hang || CFG.hangLine));
    var avail = Math.max(40, W - 4);
    var rows = [], cur = [], curW = 0;
    for (var i = 0; i < n; i++) {
      var w = S[i][0], add = (cur.length ? gap : 0) + w;
      if (cur.length && curW + add > avail) { rows.push(cur); cur = []; curW = 0; }
      cur.push(i); curW += (cur.length > 1 ? gap : 0) + w;
    }
    if (cur.length) rows.push(cur);
    var rowH = rows.map(function (r) { return Math.max.apply(null, r.map(function (i) { return S[i][1]; })); });
    var rowGap = Math.max(gap, 10);
    var totalH = rowH.reduce(function (a, b) { return a + b; }, 0) + rowGap * (rows.length - 1);
    var y = Math.max(2, hangTop - totalH / 2);
    if (y + totalH > H - 2) y = Math.max(2, H - 2 - totalH);
    rows.forEach(function (row, ri) {
      var rW = row.reduce(function (s, i) { return s + S[i][0]; }, 0) + gap * (row.length - 1);
      var x = Math.max(2, (W - rW) / 2);
      row.forEach(function (i) {
        var f = state.frames[i];
        var dy = state.align === 'top' ? 0 : state.align === 'bottom' ? (rowH[ri] - S[i][1]) : (rowH[ri] - S[i][1]) / 2;
        f.x = x; f.y = y + dy; x += S[i][0] + gap;
      });
      y += rowH[ri] + rowGap;
    });
    /* Quand la composition est plus haute ou plus large que le mur, les rangees
       continuaient au-dela du mur : a l'ecran les cadres passaient par-dessus le
       texte et les boutons de la page, et le plan imprimait des cotes
       impossibles — clou a -45 cm du sol sur un mur de 80 x 200, a -185 cm sur
       un mur de 60 x 60. On ramene chaque cadre dans le mur. La composition se
       chevauche alors visiblement, ce qui dit la verite au visiteur, et chaque
       cote imprimee reste percable. Sur un mur ou tout tient, sans effet. */
    state.frames.forEach(clampFrame);
  }
  function relayout() { if (state.scale === 'real') layoutReal(); else layoutAuto(); }
  function reorderFromPositions() {
    var items = state.frames.map(function (f) {
      var w = dimsCm(f.fmt, catById[f.id].orient)[0];
      return { f: f, cx: f.x + w / 2 };
    });
    items.sort(function (a, b) { return a.cx - b.cx; });
    state.frames = items.map(function (it) { return it.f; });
  }

  /* ---------- render ---------- */
  function renderFrames() {
    var wrap = $('#brpFrames'); wrap.innerHTML = '';
    state.frames.forEach(function (f) {
      var c = catById[f.id], d2 = dimsCm(f.fmt, c.orient);
      var d = el('div', 'br-frame' + (state.sel === f.uid ? ' sel' : ''));
      d.style.width = (d2[0] * PXCM) + 'px'; d.style.height = (d2[1] * PXCM) + 'px';
      d.style.transform = 'translate(' + (f.x * PXCM) + 'px,' + (f.y * PXCM) + 'px)';
      d.dataset.uid = f.uid;
      var img = new Image();
      img.src = imgUrl(imgOf(f), 720); img.alt = c.title;
      /* La boîte est aux vraies cotes du cadre : 30x40, 40x50, 50x70. Le mockup,
         lui, vit sur une toile 4:5 où le cadre est centré et n'occupe qu'une
         fraction connue de la surface — mesurée et constante, cf. CFG.mockup.
         On dimensionne donc la toile pour que le CADRE coïncide avec la boîte :
         la marge transparente et l'ombre débordent proprement à l'extérieur.
         Avant ce calcul, 'contain' calait l'IMAGE sur la boîte, et le cadre y
         flottait de 13 à 21 % selon le format — pas du même montant d'un format
         à l'autre. L'écart vu entre deux cadres n'était donc ni l'écart réglé ni
         celui du plan d'accrochage, qui lui a toujours été juste.
         Le ratio du cadre mesuré dans le mockup s'écarte de 1 % du ratio réel :
         caler les deux axes sur la boîte étire l'image d'autant. C'est le bon
         arbitrage — 1 % sur une photo est invisible, 15 % sur une cote ne l'est
         pas. */
      var fill = mockupFill(f.fmt, c.orient);
      img.style.position = 'absolute';
      img.style.width = (100 / fill[0]).toFixed(3) + '%';
      img.style.height = (100 / fill[1]).toFixed(3) + '%';
      img.style.left = (50 - 50 / fill[0]).toFixed(3) + '%';
      img.style.top = (50 - 50 / fill[1]).toFixed(3) + '%';
      img.loading = 'lazy'; img.decoding = 'async'; img.draggable = false;
      d.appendChild(img);
      d.addEventListener('pointerdown', onPointerDown);
      d.addEventListener('click', function () {
        if (window.innerWidth < 900 && state.previewMode === 'large') {
          state.sel = f.uid;
          refreshStage();
        }
      });
      wrap.appendChild(d);
    });
    ghostRects().forEach(function (g) {
      var d = el('button', 'br-ghost');
      d.type = 'button';
      d.style.width = (g.w * PXCM) + 'px'; d.style.height = (g.h * PXCM) + 'px';
      d.style.transform = 'translate(' + (g.x * PXCM) + 'px,' + (g.y * PXCM) + 'px)';
      /* La place vide portait un « + » muet. Elle dit maintenant ce qu'elle
         attend — c'est la moitié de la consigne, posée là où on clique. */
      d.innerHTML = '<span>+</span><i>' + esc(t('ghost_add', 'Ajouter')) + '</i>';
      d.title = t('ghost_add_title', 'Ajouter un tirage');
      d.addEventListener('click', function () { openPicker('new'); });
      wrap.appendChild(d);
    });
    $('#brpTitle').textContent = compoName();
    renderPop();
  }

  /* Les formats et les finitions disponibles pour un cadre. Le popover
     flottant et le panneau de droite affichent exactement la même chose : une
     seule source, deux emplacements. */
  function frameControlsHTML(f) {
    var fmts = fmtsAvail(f.id).map(function (k) {
      return '<button type="button" data-fmt="' + k + '" class="' + (f.fmt === k ? 'on' : '') + '">' + k + '</button>';
    }).join('');
    var avail = frameAvail(f.id, f.fmt);
    var frames = CFG.frames.map(function (fr) {
      return '<button type="button" class="br-dot ' + (f.frame === fr.key ? 'on' : '') + '" data-frame="' + fr.key + '" ' +
        (avail.indexOf(fr.key) > -1 ? '' : 'disabled') + ' title="' + esc(fr.label) + '" aria-label="' + esc(fr.label) + '" style="background:' + fr.sw + '"></button>';
    }).join('');
    return { fmts: fmts, frames: frames };
  }

  /* Le popover est le seul éditeur du cadre cliqué : il se pose sous le cadre,
     à la Apple — contextuel, discret, il disparaît quand on clique ailleurs.
     Quand rien n'est sélectionné, une ligne sous le mur dit le geste. */
  /* L'éditeur du cadre vit dans le dock, sous le mur, toujours au même
     endroit. Il porte d'abord le cartel — le nom de l'œuvre, puis l'artiste
     avec sa photo en cercle — et seulement ensuite les réglages : on sait ce
     qu'on modifie avant de le modifier. */
  function renderPop() {
    var pop = $('#brpPop');
    var f = null;
    for (var i = 0; i < state.frames.length; i++) if (state.frames[i].uid === state.sel) f = state.frames[i];
    var hint = $('#brpSelHint');
    var showPop = !!f && !state.rotated;
    if (hint) hint.hidden = showPop;
    if (!pop) return;
    if (!showPop) { pop.hidden = true; return; }
    var c = catById[f.id], d = dimsCm(f.fmt, c.orient);
    var ctl2 = frameControlsHTML(f);
    $('#brpPopFmt').innerHTML = ctl2.fmts;
    $('#brpPopFrames').innerHTML = ctl2.frames;
    $('#brpPopTitle').textContent = c.title;
    var meta = $('#brpPopArtist');
    if (meta) {
      var line = tfill('inspector_meta', '{w} × {h} cm · {price}',
        { w: d[0], h: d[1], price: money(priceOf(f)) });
      var who = '';
      if (c.artist) {
        who = (c.artistPic
          ? '<img class="br-pop__pic" src="' + esc(c.artistPic) + '" alt="" loading="lazy" decoding="async">'
          : '<span class="br-pop__pic br-pop__pic--empty" aria-hidden="true"></span>') +
          '<span class="br-pop__who">' + esc(c.artist) + '</span>';
      }
      meta.innerHTML = who + '<span class="br-pop__meta">' + esc(line) + '</span>';
    }
    pop.hidden = false;
  }

  /* `hidden` n'existe que sur HTMLElement. Un <svg> hérite d'Element : lui
     poser `.hidden = false` crée une propriété JavaScript sans jamais retirer
     l'attribut, et la règle [hidden]{display:none} continue de s'appliquer.
     On passe donc par l'attribut. */
  function showEl(el, on) {
    if (!el) return;
    if (on) el.removeAttribute('hidden');
    else el.setAttribute('hidden', '');
  }
  /* La tige. Elle relie le milieu du bord bas de l'œuvre sélectionnée au haut
     de sa carte de réglages, par un chemin à angles droits : on descend, on se
     décale une fois, on redescend. Quand la carte tombe pile sous l'œuvre, il
     ne reste qu'un trait droit — le chemin se simplifie tout seul.
     Tout est mesuré à l'écran plutôt que recalculé en centimètres : la carte
     est centrée par le flux, sa position ne se déduit d'aucun état. */
  function renderLeader() {
    var svg = $('#brpLeader'), stage = $('#brpStage'), pop = $('#brpPop');
    if (!svg || !stage) return;
    var f = selFrame();
    if (!f || state.rotated || !pop || pop.hidden || (drag && drag.moved)) { showEl(svg, false); return; }
    var frameEl = null;
    Array.prototype.forEach.call($$('.br-frame'), function (d) {
      if (+d.dataset.uid === f.uid) frameEl = d;
    });
    if (!frameEl) { showEl(svg, false); return; }
    var sr = stage.getBoundingClientRect();
    var fr = frameEl.getBoundingClientRect();
    var pr = pop.getBoundingClientRect();
    var x1 = fr.left + fr.width / 2 - sr.left;
    var y1 = fr.bottom - sr.top;
    var x2 = pr.left + pr.width / 2 - sr.left;
    var y2 = pr.top - sr.top;
    if (!(y2 > y1)) { showEl(svg, false); return; }
    svg.setAttribute('width', Math.max(1, Math.round(sr.width)));
    svg.setAttribute('height', Math.max(1, Math.round(sr.height)));
    svg.setAttribute('viewBox', '0 0 ' + Math.max(1, Math.round(sr.width)) + ' ' + Math.max(1, Math.round(sr.height)));
    var d;
    if (Math.abs(x2 - x1) < 2) {
      d = 'M' + x1 + ' ' + y1 + ' L' + x1 + ' ' + y2;
    } else {
      var mid = y1 + (y2 - y1) / 2;
      d = 'M' + x1 + ' ' + y1 + ' L' + x1 + ' ' + mid + ' L' + x2 + ' ' + mid + ' L' + x2 + ' ' + y2;
    }
    svg.innerHTML =
      '<path d="' + d + '" fill="none" stroke="currentColor" stroke-width="1.25" ' +
      'stroke-linecap="round" stroke-linejoin="round"/>' +
      '<circle cx="' + x1 + '" cy="' + y1 + '" r="2.5" fill="currentColor"/>';
    showEl(svg, true);
  }

  /* Le mur, ses réglages et la tige, sans reconstruire la galerie : c'est ce
     qu'il faut redessiner quand la sélection change. La carte fait grandir le
     dock, donc la place laissée au mur change — fit() doit repasser. */
  function refreshStage() {
    renderOptions(); fit(); renderFrames(); renderLeader();
  }

  function renderOptions() {
    var n = state.frames.length, target = state.targetCount;
    var dispo = DISPO.filter(function (d) { return d.n === target; })[0] || DISPO[0];
    $('#brpDispo').innerHTML =
      '<button type="button" class="br-count-btn" data-count-step="-1" aria-label="' + t('count_remove', 'Retirer une place') + '" ' + (target <= 2 ? 'disabled' : '') + '>−</button>' +
      '<strong class="br-count-value">' + target + '</strong>' +
      '<button type="button" class="br-count-btn" data-count-step="1" aria-label="' + t('count_add', 'Ajouter une place') + '" ' + (target >= CFG.maxFrames ? 'disabled' : '') + '>+</button>';
    var caption = $('#brpCountName');
    if (caption) caption.textContent = dispo.name;
    var allFmt = n && state.frames.every(function (f) { return f.fmt === state.frames[0].fmt; }) ? state.frames[0].fmt : null;
    $('#brpSize').innerHTML = CFG.formats.map(function (k) {
      return '<button type="button" data-gfmt="' + k + '" class="' + (allFmt === k ? 'on' : '') + '">' + k + '</button>';
    }).join('');
    var allFr = n && state.frames.every(function (f) { return f.frame === state.frames[0].frame; }) ? state.frames[0].frame : null;
    $('#brpFrameG').innerHTML =
      '<button type="button" data-gframe="perso" class="' + (n && !allFr ? 'on' : '') + '">' + t('frame_custom', 'Perso') + '</button>' +
      CFG.frames.map(function (fr) {
        return '<button type="button" class="br-dot ' + (allFr === fr.key ? 'on' : '') + '" data-gframe="' + fr.key + '" data-frame="' + fr.key + '" title="' + fr.label + '" aria-label="' + fr.label + '" style="background:' + fr.sw + '"></button>';
      }).join('');
    $('#brpGap').value = state.gap;
    $('#brpGapValue').textContent = tfill('gap_value', '{value} cm', { value: state.gap });
    Array.prototype.forEach.call($$('#brpAlign [data-align]'), function (b) {
      b.classList.toggle('on', b.dataset.align === state.align);
    });
    Array.prototype.forEach.call($$('#brpWallMode [data-wall-mode]'), function (b) {
      b.classList.toggle('on', b.dataset.wallMode === state.scale);
    });
    var hangIn = $('#brpHang'), hangOut = $('#brpHangValue'), hangRow = $('#brpHangRow');
    if (hangIn) hangIn.value = state.hang;
    if (hangOut) hangOut.textContent = tfill('gap_value', '{value} cm', { value: state.hang });
    /* La hauteur d'accrochage n'a d'effet que sur le vrai mur (et le plan) :
       en mode centré, elle s'éteint au lieu de mentir. */
    if (hangRow) hangRow.classList.toggle('is-off', state.scale !== 'real');
    /* La couleur, comme dans la barre des collections : la pastille montre le
       résultat, le curseur porte sa propre teinte, les deux boutons s'éteignent
       aux extrémités. */
    var hue = $('#brpHue');
    if (hue) {
      hue.value = state.wallColor.h;
      hue.style.setProperty('--brp-hue-color', hslToHex(state.wallColor.h, 45, 88));
    }
    var dot = $('#brpSatDot');
    if (dot) dot.style.background = wallHex();
    var down = $('#brpSatDown'), up = $('#brpSatUp');
    if (down) down.classList.toggle('is-off', state.wallColor.s <= 0);
    if (up) up.classList.toggle('is-off', state.wallColor.s >= CFG.satLevels.length - 1);
    renderPop();
  }

  function artists() {
    var seen = {}, out = [];
    CAT.forEach(function (c) {
      if (c.vendor && !seen[c.vendor]) { seen[c.vendor] = true; out.push(c.vendor); }
    });
    return out.sort(function (a, b) { return a.localeCompare(b); });
  }
  function applyCatalogFilters(list, opts) {
    opts = opts || {};
    var filter = opts.filter || state.filter;
    var collection = opts.collection || state.collection;
    var artist = opts.artist || state.artist;
    if (filter !== 'all') list = list.filter(function (c) { return c.orient === filter; });
    if (collection !== 'all') list = list.filter(function (c) { return c.cols.indexOf(collection) > -1; });
    if (artist !== 'all') list = list.filter(function (c) { return c.vendor === artist; });
    return list;
  }
  function renderArtistFilters() {
    var wrap = $('#brpArtistFilters');
    wrap.innerHTML = '<button type="button" data-artist="all" class="' + (state.artist === 'all' ? 'on' : '') + '">' + t('artist_all', 'Tous les artistes') + '</button>' +
      artists().map(function (artist) {
        return '<button type="button" data-artist="' + artist.replace(/"/g, '&quot;') + '" class="' + (state.artist === artist ? 'on' : '') + '">' + artist + '</button>';
      }).join('');
  }
  var tabSwitched = false;
  function renderGallery() {
    var wishItems = WL.read().filter(function (i) { return catById[i.h]; });
    Array.prototype.forEach.call($$('#brpTabs [data-tab]'), function (b) { b.classList.toggle('on', b.dataset.tab === state.tab); });
    $('#brpWishCount').textContent = wishItems.length;
    $('#brpLimitedCount').textContent = CAT.filter(function (c) { return !c.open; }).length;
    $('#brpOpenCount').textContent = CAT.filter(function (c) { return c.open; }).length;
    Array.prototype.forEach.call($$('#brpCols [data-c]'), function (b) {
      var c = b.dataset.c;
      b.classList.toggle('on', c === 'm' + state.colsM || +c === state.colsD);
    });
    /* Un onglet vide au chargement, c'est une page qui n'offre rien à choisir.
       Si l'onglet courant ne contient aucune œuvre alors qu'un autre en a, on
       bascule une fois, silencieusement. */
    if (!tabSwitched) {
      var counts = {
        wishlist: wishItems.length,
        limited: CAT.filter(function (c) { return !c.open; }).length,
        open: CAT.filter(function (c) { return c.open; }).length
      };
      if (!counts[state.tab]) {
        var fallback = ['limited', 'open', 'wishlist'].filter(function (k) { return counts[k]; })[0];
        if (fallback) { state.tab = fallback; tabSwitched = true; }
      }
    }

    var grid = $('#brpCatalog');
    grid.className = 'br-grid cols-' + state.colsD + ' mcols-' + state.colsM;
    var list;
    if (state.tab === 'wishlist') {
      list = wishItems.map(function (i) { return catById[i.h]; });
      if (!list.length) { grid.innerHTML = '<div class="br-empty">' + t('wishlist_empty', 'Touchez le ♥ d’un tirage pour le garder ici — pas besoin de compte.') + '</div>'; return; }
    } else if (state.tab === 'open') {
      list = CAT.filter(function (c) { return c.open; });
    } else {
      list = CAT.filter(function (c) { return !c.open; });
    }
    list = applyCatalogFilters(list);
    renderArtistFilters();
    grid.innerHTML = list.map(function (c) {
      var liked = WL.has(c.id), used = onWall(c.id);
      return '<figure class="br-card ' + (used ? 'is-used' : '') + '" data-add="' + c.id + '">' +
        '<button type="button" class="ph-like ' + (liked ? 'on' : '') + '" data-like="' + c.id + '" aria-label="' + t('wishlist_aria', 'Wishlist') + '">' +
        '<svg viewBox="0 0 24 24"><path d="M12 21s-7.5-4.7-10-9.2C.6 9 1.6 5.5 4.8 4.8 7 4.3 9 5.6 12 8.5c3-2.9 5-4.2 7.2-3.7 3.2.7 4.2 4.2 2.8 7C19.5 16.3 12 21 12 21z"/></svg></button>' +
        '<div class="br-card__img"><img src="' + imgUrl(c.thumb, 480) + '" alt="' + (c.title || '').replace(/"/g, '&quot;') + '" loading="lazy" draggable="false">' +
        (used ? '<i class="br-card__used">' + t('on_wall_badge', 'Sur le mur') + '</i>' : '') + '</div>' +
        '<figcaption>' + c.title + '</figcaption></figure>';
    }).join('') || '<div class="br-empty">' + t('gallery_empty', 'Aucun tirage pour ce filtre.') + '</div>';
  }

  /* La jauge : les crans sont les places du mur. Le curseur avance entre le
     premier cadre et le dernier cran, et chaque cran s'allume quand il est
     atteint. Une place vide sur la scène et un cran sur la barre sont le même
     objet — c'est ce qui fait que le lot se joue au lieu de se lire. */
  function renderGauge(ts) {
    var wrap = $('#brpGauge'), say = $('#brpSay');
    if (!wrap) return;
    if (!ts.on || !TIERS.steps.length) {
      /* Les crans sont éteints : la jauge disparaît, mais la phrase reste — elle
         porte alors la consigne, et la barre garde un contenu à gauche. */
      wrap.innerHTML = ''; wrap.hidden = true;
      if (say) { say.innerHTML = gaugeSay(ts); say.hidden = !say.innerHTML; }
      return;
    }
    wrap.hidden = false;
    var n = ts.n;
    var last = TIERS.steps[TIERS.steps.length - 1];
    var span = last.qty > 1 ? last.qty - 1 : 1;
    var pos = function (q) { return ((Math.min(q, last.qty) - 1) / span) * 100; };
    var pct = Math.max(0, Math.min(100, pos(Math.max(n, 1))));
    var dots = '', labels = '';
    TIERS.steps.forEach(function (s) {
      var on = n >= s.qty;
      dots += '<i class="br-gauge__dot' + (on ? ' on' : '') + (n === s.qty ? ' here' : '') +
        '" style="left:' + pos(s.qty).toFixed(2) + '%"></i>';
      /* Le bénéfice part dans un <i> : sur téléphone il est masqué, parce que la
         phrase juste au-dessus le dit déjà et que trois libellés complets
         mangeaient un quart de l'écran. */
      labels += '<span class="' + (on ? 'on' : '') + '"><b>' +
        esc(tfill('tier_qty', '{n} cadres', { n: s.qty })) + '</b><i>' + esc(tierLabel(s)) + '</i></span>';
    });
    wrap.innerHTML =
      '<div class="br-gauge__track"><i class="br-gauge__fill" style="width:' + pct.toFixed(2) + '%"></i>' + dots + '</div>' +
      '<div class="br-gauge__labels">' + labels + '</div>';
    if (say) { say.innerHTML = gaugeSay(ts); say.hidden = !say.innerHTML; }
  }

  /* Le texte de l'étape, seul endroit où il est écrit. renderStep() le pose
     dans l'intro ; la barre d'achat le reprend quand elle n'a rien de
     commercial à dire — sans quoi elle n'était qu'un bandeau blanc, ce qui est
     exactement ce que Max a vu tant que les crans sont éteints. */
  function stepText() {
    var n = state.frames.length, target = Math.max(state.targetCount, n);
    var miss = target - n;
    if (!n) return t('step_start', 'Choisissez un premier tirage dans la galerie, plus bas.');
    if (miss === 1) return t('step_more_1', 'Encore un tirage à choisir.');
    if (miss > 1) return tfill('step_more_n', 'Encore {n} tirages à choisir.', { n: miss });
    return t('step_ready', 'Votre mur est prêt. Ajustez les formats et les cadres, ou ajoutez-le au panier.');
  }

  function gaugeSay(ts) {
    /* Tant que le mur n'est pas complet, la consigne prime sur l'argument :
       on finit le mur avant de parler du palier suivant. */
    var incomplete = ts.n < Math.max(state.targetCount, ts.n);
    if (!ts.on || !ts.n || incomplete) return esc(stepText());
    var parts = [];
    if (ts.reached) parts.push('<b>' + esc(tierLabel(ts.reached)) + '</b>');
    if (ts.next) {
      var miss = ts.next.qty - ts.n;
      parts.push(esc(tfill(miss > 1 ? 'gauge_next_n' : 'gauge_next_1',
        miss > 1 ? 'encore {miss} cadres : {benefit}' : 'encore un cadre : {benefit}',
        { miss: miss, benefit: tierLabel(ts.next) })));
    } else if (ts.reached) {
      parts.push(esc(t('gauge_max', 'vous avez tout débloqué')));
    }
    return parts.join(' — ');
  }

  /* La barre est fixée : elle recouvre le bas de la page. On rend au document
     exactement la hauteur qu'elle occupe, plutôt qu'une constante CSS qui serait
     fausse dès que la phrase passe sur deux lignes. */
  function syncBarSpace() {
    var bar = $('#brpBuyBar');
    if (!bar || bar.hidden) return;
    /* En mode « un seul écran » la barre est dans le flux : elle ne recouvre
       rien, et lui réserver de la place volerait de la hauteur à la scène. */
    if (root.classList.contains('brp-app')) { root.style.paddingBottom = ''; return; }
    var h = bar.offsetHeight;
    if (h > 0) root.style.paddingBottom = (h + 22) + 'px';
  }

  /* L'état des deux volets suit la largeur : repliés sous 1100 px, où ils
     passent sous le mur et lui prendraient toute la place ; toujours ouverts
     au-dessus, où ce sont des colonnes. Sans ce rappel, un volet replié sur
     téléphone restait fermé après rotation de l'écran, sans moyen visible de
     le rouvrir sur une mise en page qui n'a plus de chevron. */
  function syncPanels() {
    var mobile = window.innerWidth < 1100;
    var first = true, anyOpen = false;
    Array.prototype.forEach.call($$('[data-panel-toggle]'), function (btn) {
      var body = document.getElementById(btn.dataset.panelToggle);
      if (!body) return;
      var open = !mobile || (first && !state.frames.length);
      body.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && mobile) anyOpen = true;
      first = false;
    });
    root.classList.toggle('has-panel', anyOpen);
  }

  /* La hauteur réellement disponible sous l'en-tête du site. On la mesure une
     fois posée, plutôt que de supposer une hauteur d'en-tête. */
  function syncViewport() {
    if (!root.classList.contains('brp-app')) return;
    var top = root.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0);
    var h = Math.max(480, Math.round(window.innerHeight - top));
    root.style.setProperty('--brp-vh', h + 'px');
  }

  function renderFoot() {
    var n = state.frames.length;
    var subtotal = state.frames.reduce(function (s, f) { return s + priceOf(f); }, 0);
    var ts = tierState();
    var grand = subtotal - ts.save;

    /* Le prix barré n'apparaît QUE s'il y a une remise que Shopify appliquera
       vraiment. Tant que les crans sont éteints, le bouton porte le prix plein
       — celui que le client paiera. */
    $('#brpSub').innerHTML = ts.save ? '<s>' + esc(money(subtotal)) + '</s>' : '';
    $('#brpTotal').textContent = n ? money(grand) : '';
    $('#brpBonus').textContent = ts.save ? tfill('you_save', '−{amount}', { amount: money(ts.save) }) : '';
    $('#brpCount').textContent = n ? tfill('bar_count', '{n} cadres', { n: n }) : '';

    renderGauge(ts);

    var btn = $('#brpAddCart'); btn.disabled = n < 1 || busy;
    btn.textContent = n < 1 ? t('cta_empty', 'Ajoutez un cadre') : (busy ? t('cta_busy', 'Ajout…') : t('cta_add_to_cart_short', 'Ajouter au panier'));

    var bar = $('#brpBuyBar');
    if (bar) { bar.hidden = false; syncBarSpace(); }

    $('#brpMyWall').textContent = state.wallConfigured
      ? tfill('wall_summary', 'Mur : {width} × {height} cm · modifier', { width: Math.round(state.wall.w), height: Math.round(state.wall.h) })
      : t('configure_wall', 'Configurer mon mur');
  }

  /* La consigne. Une seule phrase, en haut, qui dit ce qu'il reste à faire —
     la page ne l'a jamais dit, et c'est le premier reproche de Max : « on
     comprend pas ce qu'on doit faire ». Elle remplace le texte d'introduction
     générique, au même endroit. */
  function renderStep() {
    var el2 = $('#brpStep');
    if (el2) el2.textContent = stepText();
  }

  /* L'ordre compte : le dock (consigne ou éditeur du cadre) est rendu par
     renderOptions, et sa hauteur change selon qu'un cadre est sélectionné.
     fit() mesure la place qui reste au mur — il doit donc passer APRÈS, sinon
     le premier clic sur un cadre laissait le mur à son ancienne taille et le
     poussait sous l'éditeur. */
  function renderAll() { renderOptions(); fit(); renderFrames(); renderGallery(); renderFoot(); renderStep(); renderLeader(); save(); }

  /* ---------- drag = réordonner · clic = sélection ---------- */
  var drag = null;
  function onPointerDown(e) {
    if (window.innerWidth < 900 && state.previewMode === 'large' && e.pointerType === 'touch') return;
    var d = e.currentTarget, uid = +d.dataset.uid, f = null;
    state.frames.forEach(function (x) { if (x.uid === uid) f = x; });
    if (!f) return;
    try { if (d.setPointerCapture) d.setPointerCapture(e.pointerId); } catch (_) {}
    drag = { uid: uid, el: d, startX: e.clientX, startY: e.clientY, origX: f.x, origY: f.y, moved: false };
    d.classList.add('is-drag');
    document.addEventListener('pointermove', onPointerMove);
    document.addEventListener('pointerup', onPointerUp, { once: true });
    e.preventDefault();
  }
  function onPointerMove(e) {
    if (!drag) return;
    var dx = (e.clientX - drag.startX) / PXCM;
    if (Math.abs(e.clientX - drag.startX) > 4 || Math.abs(e.clientY - drag.startY) > 4) {
      if (!drag.moved) {
        var p = $('#brpPop'); if (p) p.hidden = true;
        showEl($('#brpLeader'), false);
      }
      drag.moved = true;
    }
    var f = null; state.frames.forEach(function (x) { if (x.uid === drag.uid) f = x; });
    f.x = drag.origX + dx;
    drag.el.style.transform = 'translate(' + (f.x * PXCM) + 'px,' + (f.y * PXCM) + 'px)';
  }
  function onPointerUp(e) {
    if (!drag) return;
    drag.el.classList.remove('is-drag');
    if (!drag.moved) {
      var now = Date.now();
      if (onPointerUp._uid === drag.uid && now - (onPointerUp._t || 0) < 350) { state.sel = drag.uid; openPicker(drag.uid); }
      else if (state.sel === drag.uid) { deselect(); }
      else {
        state.sel = drag.uid;
        refreshStage();
      }
      onPointerUp._t = now; onPointerUp._uid = drag.uid;
    } else { reorderFromPositions(); relayout(); renderAll(); }
    document.removeEventListener('pointermove', onPointerMove);
    drag = null;
  }
  /* drag depuis la galerie (clic simple = ajouter) */
  var shelfDrag = null;
  function onShelfDown(e) {
    var it = e.target.closest('[data-add]'); if (!it) return;
    if (e.target.closest('.ph-like')) return;
    shelfDrag = { id: it.dataset.add, x: e.clientX, y: e.clientY, started: false, clone: null };
    document.addEventListener('pointermove', onShelfMove);
    document.addEventListener('pointerup', onShelfUp, { once: true });
  }
  function onShelfMove(e) {
    if (!shelfDrag) return;
    if (!shelfDrag.started && Math.hypot(e.clientX - shelfDrag.x, e.clientY - shelfDrag.y) > 6) {
      shelfDrag.started = true;
      var c = catById[shelfDrag.id];
      var cl = el('img', 'br-dragclone'); cl.src = imgUrl(c.thumb, 240); document.body.appendChild(cl);
      shelfDrag.clone = cl;
    }
    if (shelfDrag.clone) {
      shelfDrag.clone.style.left = e.clientX + 'px'; shelfDrag.clone.style.top = e.clientY + 'px';
      var r = $('#brpCanvas').getBoundingClientRect();
      shelfDrag.clone.classList.toggle('ok', e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom);
    }
  }
  function onShelfUp(e) {
    if (!shelfDrag) return;
    var wasStarted = shelfDrag.started;
    if (shelfDrag.clone) shelfDrag.clone.remove();
    var id = shelfDrag.id; shelfDrag = null;
    document.removeEventListener('pointermove', onShelfMove);
    if (wasStarted) {
      var r = $('#brpCanvas').getBoundingClientRect();
      if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) addFrame(id);
    } else addFrame(id);
  }

  /* ---------- actions ---------- */
  function deselect() {
    state.sel = null;
    Array.prototype.forEach.call($$('.br-frame'), function (d) { d.classList.remove('sel'); });
    refreshStage();
  }
  function addFrame(id) {
    if (state.frames.length >= CFG.maxFrames) { toast(tfill('toast_max_frames', 'Maximum {max} cadres', { max: CFG.maxFrames })); return; }
    if (onWall(id)) { toast(t('toast_already_on_wall', 'Déjà sur le mur')); return; }
    var c = catById[id]; if (!c) return;
    var ref = state.frames[state.frames.length - 1];
    var fmt = ref ? matchFormat(id, c.orient, dimsCm(ref.fmt, catById[ref.id].orient)[1]) : (c.fmts.indexOf('A3') > -1 ? 'A3' : c.fmts[0]);
    var frame = ref ? ref.frame : 'noir';
    if (frameAvail(id, fmt).indexOf(frame) < 0) frame = frameAvail(id, fmt)[0];
    state.frames.push({ uid: uidSeq++, id: id, fmt: fmt, frame: frame, x: 0, y: 0 });
    if (state.frames.length > state.targetCount) state.targetCount = state.frames.length;
    relayout(); state.sel = null; renderAll();
  }
  function removeFrame(uid) {
    state.frames = state.frames.filter(function (f) { return f.uid !== uid; });
    if (state.sel === uid) state.sel = null;
    relayout(); renderAll();
  }
  function setCount(n) {
    n = Math.max(2, Math.min(CFG.maxFrames, n));
    state.targetCount = n;
    if (state.frames.length > n) state.frames = state.frames.slice(0, n);
    var still = false; state.frames.forEach(function (f) { if (f.uid === state.sel) still = true; });
    if (!still) state.sel = null;
    relayout(); renderAll();
  }
  function setGlobalFormat(k) {
    state.frames.forEach(function (f) {
      var target = k === 'random'
        ? fmtsAvail(f.id)[(Math.random() * fmtsAvail(f.id).length) | 0]
        : (fmtsAvail(f.id).indexOf(k) > -1 ? k : f.fmt);
      f.fmt = target;
      if (frameAvail(f.id, f.fmt).indexOf(f.frame) < 0) f.frame = frameAvail(f.id, f.fmt)[0];
    });
    relayout(); renderAll();
  }
  function setGlobalFrame(k) {
    if (k === 'perso') { toast(t('toast_custom_hint', 'Cliquez un cadre sur le mur pour le personnaliser')); return; }
    state.frames.forEach(function (f) {
      var av = frameAvail(f.id, f.fmt);
      f.frame = k === 'random' ? av[(Math.random() * av.length) | 0] : (av.indexOf(k) > -1 ? k : f.frame);
    });
    renderAll();
  }
  function selFrame() { var f = null; state.frames.forEach(function (x) { if (x.uid === state.sel) f = x; }); return f; }
  function setSelFormat(k) {
    var f = selFrame(); if (!f) return;
    f.fmt = k;
    if (frameAvail(f.id, k).indexOf(f.frame) < 0) f.frame = frameAvail(f.id, k)[0];
    relayout(); renderAll();
  }
  function setSelFrame(k) {
    var f = selFrame(); if (!f) return;
    if (frameAvail(f.id, f.fmt).indexOf(k) > -1) f.frame = k;
    renderAll();
  }
  function toggleLike(id) {
    var c = catById[id]; if (!c) return;
    var f0 = { fmt: c.fmts[0], frame: frameAvail(id, c.fmts[0])[0], id: id };
    var e = entry(f0);
    var added = WL.toggle({ h: id, id: e ? e.vid : '', t: c.title, u: c.url, img: c.thumb, p: e ? money(e.price) : '', at: Date.now() });
    if (added) toast(t('toast_wishlist_added', '🤍 Gardé dans votre wishlist'));
    renderGallery();
  }

  /* ---------- picker ---------- */
  function openPicker(target) { state.pickerTarget = target; $('#brpPicker').hidden = false; renderPicker(); }
  function closePicker() { $('#brpPicker').hidden = true; state.pickerTarget = null; }
  function renderPicker() {
    var cur = null;
    if (state.pickerTarget && state.pickerTarget !== 'new') {
      state.frames.forEach(function (f) { if (f.uid === state.pickerTarget) cur = f.id; });
    }
    var grid = $('#brpPickerGrid');
    grid.className = 'br-modal__grid picker-cols-' + state.pickerCols;
    Array.prototype.forEach.call($$('#brpPickerDensity [data-picker-cols]'), function (b) {
      b.classList.toggle('on', +b.dataset.pickerCols === state.pickerCols);
    });
    Array.prototype.forEach.call($$('#brpPickerOrientation [data-picker-filter]'), function (b) {
      b.classList.toggle('on', b.dataset.pickerFilter === state.pickerFilter);
    });
    var colSelect = $('#brpPickerCollection');
    colSelect.innerHTML = '<option value="all">' + t('all_collections', 'Toutes les collections') + '</option>' +
      Array.prototype.map.call($$('#brpCollectionFilters [data-collection]:not([data-collection="all"])'), function (b) {
        return '<option value="' + b.dataset.collection + '">' + b.textContent.trim() + '</option>';
      }).join('');
    colSelect.value = state.pickerCollection;
    var artistSelect = $('#brpPickerArtist');
    artistSelect.innerHTML = '<option value="all">' + t('artist_all', 'Tous les artistes') + '</option>' +
      artists().map(function (artist) { return '<option value="' + artist.replace(/"/g, '&quot;') + '">' + artist + '</option>'; }).join('');
    artistSelect.value = state.pickerArtist;
    var pickerList = CAT.slice();
    if (state.pickerEdition === 'limited') pickerList = pickerList.filter(function (c) { return !c.open; });
    if (state.pickerEdition === 'open') pickerList = pickerList.filter(function (c) { return c.open; });
    if (state.pickerEdition === 'wishlist') {
      var wished = {};
      WL.read().forEach(function (i) { wished[i.h] = true; });
      pickerList = pickerList.filter(function (c) { return wished[c.id]; });
    }
    $('#brpPickerEdition').value = state.pickerEdition;
    pickerList = applyCatalogFilters(pickerList, {
      filter: state.pickerFilter,
      collection: state.pickerCollection,
      artist: state.pickerArtist
    });
    grid.innerHTML = pickerList.map(function (c) {
      var liked = WL.has(c.id);
      return '<figure class="br-card ' + (cur === c.id ? 'on' : '') + '" data-pick="' + c.id + '">' +
        '<button type="button" class="ph-like ' + (liked ? 'on' : '') + '" data-like="' + c.id + '" aria-label="' + t('wishlist_aria', 'Wishlist') + '">' +
        '<svg viewBox="0 0 24 24"><path d="M12 21s-7.5-4.7-10-9.2C.6 9 1.6 5.5 4.8 4.8 7 4.3 9 5.6 12 8.5c3-2.9 5-4.2 7.2-3.7 3.2.7 4.2 4.2 2.8 7C19.5 16.3 12 21 12 21z"/></svg></button>' +
        '<div class="br-card__img"><img src="' + imgUrl(c.thumb, 480) + '" alt="" loading="lazy"></div>' +
        '<figcaption>' + c.title + '</figcaption></figure>';
    }).join('') || '<div class="br-empty">' + t('picker_empty', 'Aucun tirage pour ces filtres.') + '</div>';
  }
  function choose(id) {
    if (state.pickerTarget === 'new') { closePicker(); addFrame(id); return; }
    var f = selFrame();
    if (f && state.pickerTarget === f.uid) {
      if (onWall(id) && f.id !== id) { toast(t('toast_already_on_wall', 'Déjà sur le mur')); return; }
      f.id = id;
      if (fmtsAvail(id).indexOf(f.fmt) < 0) f.fmt = fmtsAvail(id)[0];
      if (frameAvail(id, f.fmt).indexOf(f.frame) < 0) f.frame = frameAvail(id, f.fmt)[0];
      relayout(); renderAll();
    }
    closePicker();
  }

  /* ---------- mon mur + plan ---------- */
  function clampNum(v, min, max, def) { v = parseFloat(v); if (!isFinite(v)) return def; return Math.max(min, Math.min(max, v)); }
  function applyWall() {
    state.wall.w = clampNum($('#brpWallW').value, 60, 800, 200);
    state.wall.h = clampNum($('#brpWallH').value, 60, 500, 250);
    state.wallConfigured = true;
    state.scale = 'real';
    relayout(); renderAll();
    $('#brpWallModal').hidden = true;
    toast(t('toast_wall_applied', '📏 Composition positionnée à 1,60 m — la hauteur d’accrochage standard'));
  }
  function buildPrint() {
    var area = document.getElementById('brpPrintArea');
    var W = state.wall.w, H = state.wall.h, vw = 520, sc = vw / W, vh = H * sc;
    var hang = state.hang || CFG.hangLine;
    var rects = '', rows = '';
    state.frames.forEach(function (f, i) {
      var c = catById[f.id], d = dimsCm(f.fmt, c.orient);
      var x = f.x * sc, y = f.y * sc, ww = d[0] * sc, hh = d[1] * sc;
      var nx = (f.x + d[0] / 2) * sc, ny = (f.y + CFG.drillDrop) * sc;
      rects += '<rect x="' + x.toFixed(1) + '" y="' + y.toFixed(1) + '" width="' + ww.toFixed(1) + '" height="' + hh.toFixed(1) + '" fill="#efeae1" stroke="#1c1916" stroke-width="1"/>' +
        '<text x="' + (x + ww / 2).toFixed(1) + '" y="' + (y + hh / 2 + 4).toFixed(1) + '" text-anchor="middle" font-size="13" fill="#1c1916" font-family="serif">' + (i + 1) + '</text>' +
        '<circle cx="' + nx.toFixed(1) + '" cy="' + ny.toFixed(1) + '" r="3" fill="#c0563f"/>';
      var cx = Math.round(f.x + d[0] / 2), nail = Math.round(H - f.y - CFG.drillDrop);
      rows += '<tr><td>' + (i + 1) + '</td><td>' + c.title + '</td><td>' + tfill('print_cell_format', '{fmt} · {frame}', { fmt: f.fmt, frame: f.frame }) + '</td><td>' + cx + ' cm</td><td>' + nail + ' cm</td></tr>';
    });
    area.innerHTML =
      '<div style="font-family:Archivo,sans-serif;color:#1c1916;padding:24px">' +
      '<div style="display:flex;justify-content:space-between;align-items:baseline;border-bottom:2px solid #1c1916;padding-bottom:10px;margin-bottom:18px">' +
      '<div style="font-size:24px;font-weight:500">' + t('print_title_html', 'Bisou Rivage — Plan d\'accrochage') + '</div>' +
      '<div style="font-size:12px;color:#6b6357">' + tfill('print_wall_line', 'Mur {width} × {height} cm · {date}', { width: Math.round(W), height: Math.round(H), date: new Date().toLocaleDateString(document.documentElement.lang || 'fr-FR') }) + '</div></div>' +
      '<div style="display:flex;gap:28px;flex-wrap:wrap">' +
      '<svg width="' + vw + '" height="' + vh.toFixed(0) + '" viewBox="0 0 ' + vw + ' ' + vh.toFixed(0) + '" style="border:1px solid #ddd;background:' + wallHex() + '">' +
      '<line x1="0" y1="' + ((H - hang) * sc).toFixed(1) + '" x2="' + vw + '" y2="' + ((H - hang) * sc).toFixed(1) + '" stroke="#9a7a4b" stroke-dasharray="4 4" stroke-width="1"/>' +
      rects + '</svg>' +
      '<div style="flex:1;min-width:280px"><table style="width:100%;border-collapse:collapse;font-size:13px">' +
      '<thead><tr style="text-align:left;border-bottom:1px solid #1c1916"><th>#</th><th>' + t('print_col_print', 'Tirage') + '</th><th>' + t('print_col_format', 'Format') + '</th><th>' + t('print_col_center', 'Centre / bord G') + '</th><th>' + t('print_col_nail', 'Clou / sol') + '</th></tr></thead>' +
      '<tbody>' + rows + '</tbody></table>' +
      '<p style="font-size:12px;color:#6b6357;margin-top:14px;line-height:1.6">' +
      tfill('print_note_drill', '• Le point rouge = où percer : centre horizontal du cadre, {drop} cm sous son bord supérieur.', { drop: CFG.drillDrop }) + '<br>' +
      tfill('print_note_hangline_html', '• La ligne dorée = hauteur d\'accrochage standard ({height} cm du sol, au centre de la composition).', { height: hang }) + '<br>' +
      t('print_note_measures_html', '• Mesures depuis le bord <b>gauche</b> du mur et depuis le <b>sol</b>.') + '</p></div></div></div>';
  }

  /* ---------- panier réel ---------- */
  var busy = false;
  function addCart() {
    var n = state.frames.length; if (n < 1 || busy) return;
    var items = [];
    var compoId = 'compo-' + Date.now();
    var name = compoSlug();
    for (var i = 0; i < state.frames.length; i++) {
      var e = entry(state.frames[i]);
      if (!e) { toast(t('toast_variant_missing', 'Variante introuvable — réessayez')); return; }
      if (!e.av) { toast(tfill('toast_sold_out', '« {title} » est épuisé dans ce format', { title: catById[state.frames[i].id].title })); return; }
      items.push({ id: e.vid, quantity: 1, properties: { '_compo': compoId, 'Composition': name + ' (' + n + ' cadres)' } });
    }
    busy = true; renderFoot();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      /* Plus de détour par /discount/. Les crans sont des remises automatiques :
         Shopify les applique seul, et le panier affiche le montant réel. */
      window.location.href = CFG.cartUrl;
    }).catch(function () {
      busy = false; renderFoot();
      toast(t('toast_cart_error', 'Impossible d’ajouter au panier — réessayez'));
    });
  }

  /* ---------- toast ---------- */
  var toastTimer = null;
  function toast(msg) {
    var t = $('#brpToast'); t.textContent = msg; t.classList.add('show');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2400);
  }

  /* ---------- modes d'aperçu ---------- */
  function renderPreviewModes() {
    Array.prototype.forEach.call($$('#brpPreviewModes [data-preview]'), function (b) {
      b.classList.toggle('on', b.dataset.preview === state.previewMode);
    });
    var rotate = $('#brpPreviewModes [data-rotate]');
    if (rotate) rotate.classList.toggle('on', state.rotated);
    $('#brpPreviewZoom').classList.toggle('show', state.previewMode === 'large');
  }
  function setFullscreen(active) {
    if (active && state.scale === 'real') {
      state.fsRestoreScale = 'real';
      state.scale = 'auto';
      relayout();
    } else if (!active && state.fsRestoreScale) {
      state.scale = state.fsRestoreScale;
      state.fsRestoreScale = null;
      relayout();
    }
    root.classList.toggle('br-fs', active);
    root.classList.remove('br-preview-large');
    state.previewMode = active ? 'fullscreen' : 'normal';
    $('#brpFs').setAttribute('aria-expanded', active ? 'true' : 'false');
    $('#brpFs').setAttribute('aria-label', active ? t('fullscreen_close', 'Fermer le plein écran') : t('fullscreen', 'Plein écran'));
    renderPreviewModes(); fit(); renderFrames(); renderLeader();
  }
  function setPreviewMode(mode) {
    if (mode === 'fullscreen') { setFullscreen(!root.classList.contains('br-fs')); return; }
    if (root.classList.contains('br-fs')) setFullscreen(false);
    root.classList.toggle('br-preview-large', mode === 'large');
    state.previewMode = mode === 'large' ? 'large' : 'normal';
    $('#brpFs').setAttribute('aria-expanded', 'false');
    $('#brpFs').setAttribute('aria-label', t('fullscreen', 'Plein écran'));
    renderPreviewModes(); fit(); renderFrames();
  }

  /* ---------- wiring ---------- */
  function wire() {
    $('#brpDispo').addEventListener('click', function (e) {
      var b = e.target.closest('[data-count-step]');
      if (!b || b.disabled) return;
      var step = +b.dataset.countStep;
      /* Le « + » ouvre la fenêtre de choix au lieu de poser une place vide :
         ajouter un cadre, c'est choisir une œuvre. La place vide était un
         détour — on cliquait « + », puis il fallait comprendre qu'il restait
         un trou à remplir. */
      if (step > 0) {
        if (state.frames.length >= CFG.maxFrames) { toast(tfill('toast_max_frames', 'Maximum {max} cadres', { max: CFG.maxFrames })); return; }
        openPicker('new');
        return;
      }
      setCount(state.targetCount + step);
    });
    $('#brpSize').addEventListener('click', function (e) { var b = e.target.closest('[data-gfmt]'); if (b) setGlobalFormat(b.dataset.gfmt); });
    $('#brpFrameG').addEventListener('click', function (e) { var b = e.target.closest('[data-gframe]'); if (b) setGlobalFrame(b.dataset.gframe); });
    $('#brpShuffleSize').addEventListener('click', function () { setGlobalFormat('random'); });
    $('#brpShuffleFrames').addEventListener('click', function () { setGlobalFrame('random'); });
    $('#brpGap').addEventListener('input', function (e) {
      state.gap = Math.max(2, Math.min(25, +e.target.value || 7));
      relayout(); renderAll();
    });
    $('#brpWallMode').addEventListener('click', function (e) {
      var b = e.target.closest('[data-wall-mode]'); if (!b) return;
      if (b.dataset.wallMode === 'real' && !state.wallConfigured) {
        $('#brpWallModal').hidden = false;
        return;
      }
      state.scale = b.dataset.wallMode;
      relayout(); renderAll();
    });
    $('#brpHue').addEventListener('input', function (e) {
      state.wallColor.hex = null;
      state.wallColor.h = +e.target.value;
      if (state.wallColor.s === 0) state.wallColor.s = 2;
      fit(); renderOptions(); save();
    });
    /* Les deux volets se replient sous 1100 px, où ils passent sous le mur.
       Sur ordinateur l'en-tête n'est qu'un titre : on ne replie pas une colonne
       qui a la place de rester ouverte. */
    Array.prototype.forEach.call($$('[data-panel-toggle]'), function (btn) {
      btn.addEventListener('click', function () {
        if (window.innerWidth >= 1100) return;
        var body = document.getElementById(btn.dataset.panelToggle);
        if (!body) return;
        var open = btn.getAttribute('aria-expanded') !== 'true';
        /* Un seul volet ouvert à la fois : sur un téléphone, deux volets
           dépliés ne laissent plus rien au mur. */
        if (open) {
          Array.prototype.forEach.call($$('[data-panel-toggle]'), function (other) {
            if (other === btn) return;
            var ob = document.getElementById(other.dataset.panelToggle);
            if (ob) { ob.hidden = true; other.setAttribute('aria-expanded', 'false'); }
          });
        }
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        body.hidden = !open;
        root.classList.toggle('has-panel', open);
        /* Pas de scrollIntoView : il faisait défiler la page entière, le mur
           sortait par le haut et le pied de page apparaissait sous la caisse.
           Le volet est borné en hauteur — il tient sous son en-tête, et défile
           dans lui-même s'il est long. */
        syncViewport(); fit(); renderFrames(); renderLeader();
      });
    });
    $('#brpSatUp').addEventListener('click', function () { state.wallColor.hex = null; state.wallColor.s = Math.min(CFG.satLevels.length - 1, state.wallColor.s + 1); fit(); renderOptions(); save(); });
    $('#brpSatDown').addEventListener('click', function () { state.wallColor.hex = null; state.wallColor.s = Math.max(0, state.wallColor.s - 1); fit(); renderOptions(); save(); });
    $('#brpPopFmt').addEventListener('click', function (e) { var b = e.target.closest('[data-fmt]'); if (b) setSelFormat(b.dataset.fmt); });
    $('#brpPopFrames').addEventListener('click', function (e) { var b = e.target.closest('[data-frame]'); if (b && !b.disabled) setSelFrame(b.dataset.frame); });
    $('#brpPopSwap').addEventListener('click', function () { if (state.sel) openPicker(state.sel); });
    $('#brpPopDel').addEventListener('click', function () { if (state.sel) removeFrame(state.sel); });
    $('#brpAlign').addEventListener('click', function (e) {
      var b = e.target.closest('[data-align]'); if (!b) return;
      state.align = b.dataset.align;
      relayout(); renderAll();
    });
    $('#brpHang').addEventListener('input', function (e) {
      state.hang = Math.max(120, Math.min(200, +e.target.value || CFG.hangLine));
      $('#brpHangValue').textContent = tfill('gap_value', '{value} cm', { value: state.hang });
      if (state.scale === 'real') { relayout(); renderAll(); } else save();
    });
    $('#brpAdd').addEventListener('click', function () { openPicker('new'); });
    $('#brpFs').addEventListener('click', function () { setFullscreen(!root.classList.contains('br-fs')); });
    /* La rotation : elle n'existait que dans la barre de modes, que le mode
       « un seul écran » masque. Elle devient un bouton du plein écran. */
    var rotBtn = $('#brpRotate');
    if (rotBtn) rotBtn.addEventListener('click', function () {
      state.rotated = !state.rotated;
      rotBtn.classList.toggle('on', state.rotated);
      deselect(); renderPreviewModes(); fit(); renderFrames(); renderLeader();
    });
    $('#brpPreviewModes').addEventListener('click', function (e) {
      var mode = e.target.closest('[data-preview]');
      var rotate = e.target.closest('[data-rotate]');
      if (mode) setPreviewMode(mode.dataset.preview);
      if (rotate) {
        state.rotated = !state.rotated;
        deselect(); renderPreviewModes(); fit(); renderFrames();
      }
      var zoom = e.target.closest('[data-preview-zoom]');
      if (zoom) {
        state.largeZoom = Math.max(1.25, Math.min(2.8, state.largeZoom + (+zoom.dataset.previewZoom * .2)));
        fit(); renderFrames();
      }
    });
    $('#brpStage').addEventListener('pointerdown', function (e) {
      if (!e.target.closest('.br-frame') && !e.target.closest('.br-ghost') && !e.target.closest('#brpFs') && !e.target.closest('#brpPreviewModes') && !e.target.closest('.br-pop')) deselect();
    });
    $('#brpTabs').addEventListener('click', function (e) { var b = e.target.closest('[data-tab]'); if (b) { state.tab = b.dataset.tab; renderGallery(); } });
    $('#brpCollectionFilters').addEventListener('click', function (e) {
      var b = e.target.closest('[data-collection]'); if (!b) return;
      state.collection = b.dataset.collection;
      Array.prototype.forEach.call($$('#brpCollectionFilters [data-collection]'), function (x) { x.classList.toggle('on', x === b); });
      renderGallery();
    });
    $('#brpArtistFilters').addEventListener('click', function (e) {
      var b = e.target.closest('[data-artist]'); if (!b) return;
      state.artist = b.dataset.artist;
      renderGallery();
    });
    Array.prototype.forEach.call($$('[data-collection-scroll]'), function (b) {
      b.addEventListener('click', function () {
        $('#brpCollectionFilters').scrollBy({ left: (+b.dataset.collectionScroll) * 280, behavior: 'smooth' });
      });
    });
    (function () {
      var track = $('#brpCollectionFilters'), drag = null;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        drag = { x: e.clientX, left: track.scrollLeft };
        track.setPointerCapture(e.pointerId);
      });
      track.addEventListener('pointermove', function (e) {
        if (!drag) return;
        track.scrollLeft = drag.left - (e.clientX - drag.x);
      });
      track.addEventListener('pointerup', function () { drag = null; });
      track.addEventListener('pointercancel', function () { drag = null; });
    })();
    $('#brpFilters').addEventListener('click', function (e) {
      var b = e.target.closest('[data-f]');
      if (b) {
        state.filter = b.dataset.f;
        Array.prototype.forEach.call($$('#brpFilters [data-f]'), function (x) { x.classList.toggle('on', x === b); });
        renderGallery();
      }
    });
    $('#brpCols').addEventListener('click', function (e) {
      var b = e.target.closest('[data-c]'); if (!b) return;
      var c = b.dataset.c;
      if (c.charAt(0) === 'm') state.colsM = +c.slice(1); else state.colsD = +c;
      renderGallery(); save();
    });
    $('#brpCatalog').addEventListener('click', function (e) {
      var lk = e.target.closest('[data-like]'); if (lk) { toggleLike(lk.dataset.like); }
    });
    $('#brpCatalog').addEventListener('pointerdown', onShelfDown);
    $('#brpAddCart').addEventListener('click', addCart);
    $('#brpMyWall').addEventListener('click', function () {
      $('#brpWallModal').hidden = false;
      $('#brpWallW').value = Math.round(state.wall.w); $('#brpWallH').value = Math.round(state.wall.h);
    });
    $('#brpWallApply').addEventListener('click', applyWall);
    $('#brpPrint').addEventListener('click', function () {
      /* Le plan a besoin d'un vrai mur pour donner des cotes depuis le sol.
         S'il n'est pas encore configuré, on le demande au lieu de cacher le
         bouton — le visiteur découvrait le plan par accident. */
      if (!state.wallConfigured) {
        $('#brpWallModal').hidden = false;
        $('#brpWallW').value = Math.round(state.wall.w); $('#brpWallH').value = Math.round(state.wall.h);
        return;
      }
      if (state.scale !== 'real') { state.scale = 'real'; relayout(); renderAll(); }
      buildPrint();
      /* Le plan est enfoui dans main > section > div : aucune regle @media print
         ne peut couper la mise en page de ses ancetres. On le remonte une fois
         sous <body>, la feuille de style fait le reste. A l'ecran il reste
         invisible (.brp-print{display:none}). */
      var area = document.getElementById('brpPrintArea');
      if (area && area.parentNode !== document.body) document.body.appendChild(area);
      document.documentElement.classList.add('brp-printing');
      window.print();
    });
    window.addEventListener('afterprint', function () {
      document.documentElement.classList.remove('brp-printing');
    });
    function wirePanelToggle(buttonSel, panelSel) {
      $(buttonSel).addEventListener('click', function () {
        var panel = $(panelSel);
        var open = panel.hidden;
        panel.hidden = !open;
        this.setAttribute('aria-expanded', open ? 'true' : 'false');
        this.querySelector('span').textContent = open ? t('hide', 'Masquer') : t('panel_show', 'Afficher');
      });
    }
    wirePanelToggle('#brpSettingsToggle', '#brpSettingsPanel');
    /* Les replis secondaires : leur libellé ne change pas — le bouton dit ce
       qu'il ouvre, pas son état, l'état est porté par la flèche. */
    function wireMore(buttonSel, panelSel) {
      var btn = $(buttonSel);
      if (!btn) return;
      btn.addEventListener('click', function () {
        var panel = $(panelSel);
        var open = panel.hidden;
        panel.hidden = !open;
        this.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
    wireMore('#brpFiltersToggle', '#brpMoreFilters');
    wirePanelToggle('#brpGalleryToggle', '#brpGalleryPanel');
    $('#brpPickerOrientation').addEventListener('click', function (e) {
      var b = e.target.closest('[data-picker-filter]'); if (!b) return;
      state.pickerFilter = b.dataset.pickerFilter; renderPicker();
    });
    $('#brpPickerCollection').addEventListener('change', function (e) { state.pickerCollection = e.target.value; renderPicker(); });
    $('#brpPickerEdition').addEventListener('change', function (e) { state.pickerEdition = e.target.value; renderPicker(); });
    $('#brpPickerArtist').addEventListener('change', function (e) { state.pickerArtist = e.target.value; renderPicker(); });
    $('#brpPickerDensity').addEventListener('click', function (e) {
      var b = e.target.closest('[data-picker-cols]'); if (!b) return;
      state.pickerCols = +b.dataset.pickerCols;
      renderPicker();
    });
    ['#brpWallModal', '#brpPicker'].forEach(function (sel) {
      $(sel).addEventListener('click', function (e) {
        if (e.target.dataset.close !== undefined || e.target.closest('[data-close]')) { $(sel).hidden = true; state.pickerTarget = null; return; }
        if (sel === '#brpPicker') {
          var lk = e.target.closest('[data-like]'); if (lk) { toggleLike(lk.dataset.like); renderPicker(); return; }
          var pk = e.target.closest('[data-pick]'); if (pk) choose(pk.dataset.pick);
        }
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (!$('#brpPicker').hidden) { closePicker(); return; }
        if (!$('#brpWallModal').hidden) { $('#brpWallModal').hidden = true; return; }
        if (root.classList.contains('br-fs')) { setFullscreen(false); return; }
        deselect(); return;
      }
      if (/^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName) || !$('#brpPicker').hidden) return;
      var f = selFrame(); if (!f) return;
      if (e.key === 'Delete' || e.key === 'Backspace') { e.preventDefault(); removeFrame(state.sel); return; }
      var i = state.frames.indexOf(f);
      if (e.key === 'ArrowLeft' && i > 0) { state.frames.splice(i, 1); state.frames.splice(i - 1, 0, f); }
      else if (e.key === 'ArrowRight' && i < state.frames.length - 1) { state.frames.splice(i, 1); state.frames.splice(i + 1, 0, f); }
      else return;
      e.preventDefault(); relayout(); renderAll();
    });
    var rt, lastMobile = window.innerWidth < 1100;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        var mobile = window.innerWidth < 1100;
        if (mobile !== lastMobile) { lastMobile = mobile; syncPanels(); }
        syncViewport(); fit(); renderFrames(); syncBarSpace(); renderLeader();
      }, 120);
    });
    document.addEventListener('bisou:wishlist', function () { renderGallery(); });
    document.addEventListener('click', function (e) {
      if (!state.sel) return;
      if (e.target.closest('#BRPlanner .br-frame') || e.target.closest('#BRPlanner .br-pop')) return;
      deselect();
    });
  }

  /* ---------- start ---------- */
  function start() {
    if (root.dataset.brpInit) return;
    root.dataset.brpInit = '1';
    wire();
    var q = new URLSearchParams(window.location.search);
    var pid = q.get('id');
    var idsParam = q.get('ids');
    var seededFromIds = false;
    if (idsParam) {
      /* DIPTYQUE (et + ) : plusieurs handles séparés par des virgules, dans l'ordre */
      var wanted = idsParam.split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
      var seeded = [];
      wanted.forEach(function (h) { if (catById[h] && seeded.indexOf(catById[h]) < 0) seeded.push(catById[h]); });
      if (seeded.length) {
        state.frames = [];
        seeded.forEach(function (c) { addSilently(c); });
        state.targetCount = Math.max(2, state.frames.length);
        seededFromIds = true;
      }
    }
    if (seededFromIds) {
      /* déjà seedé depuis ?ids= */
    } else if (pid && catById[pid]) {
      var c = catById[pid];
      var fmt = c.fmts.indexOf('A3') > -1 ? 'A3' : c.fmts[0];
      state.frames = [{ uid: uidSeq++, id: pid, fmt: fmt, frame: frameAvail(pid, fmt)[0], x: 0, y: 0 }];
      state.targetCount = 2;
    } else if (q.has('vide')) {
      state.frames = [];
      state.targetCount = 2;
    } else if (!load() || !state.frames.length) {
      // défaut : les 3 premiers tirages du catalogue, accord des hauteurs
      state.frames = [];
      for (var i = 0; i < Math.min(3, CAT.length); i++) addSilently(CAT[i]);
      state.targetCount = Math.max(2, state.frames.length);
    }
    state.targetCount = Math.max(2, Math.min(CFG.maxFrames, Math.max(state.targetCount, state.frames.length)));
    /* La fenêtre de choix sert à piocher : sur grand écran on veut voir des
       œuvres, pas deux vignettes géantes. */
    if (window.innerWidth >= 1100) state.pickerCols = 4;
    syncPanels();
    syncViewport();
    relayout(); renderPreviewModes(); renderAll();
    /* Un second passage après la mise en page : au premier, la scène n'a pas
       encore sa hauteur et fit() se rabat sur son repli. */
    requestAnimationFrame(function () { syncViewport(); fit(); renderFrames(); });
    /* Sur téléphone, seuls les RÉGLAGES se replient. La galerie est devenue
       l'étape 1 : la replier revenait à dire « choisissez un tirage plus bas »
       en cachant les tirages derrière un bouton. */
    /* En mode « un seul écran » rien ne se replie : il n'y a plus de défilement
       à économiser, et replier les réglages privait le visiteur du format et de
       la finition sans lui laisser de moyen de les rouvrir sous les yeux. */
    if (window.innerWidth < 900 && !root.classList.contains('brp-app')) {
      $('#brpSettingsPanel').hidden = true;
      $('#brpSettingsToggle').setAttribute('aria-expanded', 'false');
      $('#brpSettingsToggle span').textContent = t('panel_show', 'Afficher');
    }
    function addSilently(c) {
      var ref = state.frames[state.frames.length - 1];
      var fmt = ref ? matchFormat(c.id, c.orient, dimsCm(ref.fmt, catById[ref.id].orient)[1]) : (c.fmts.indexOf('A3') > -1 ? 'A3' : c.fmts[0]);
      var frame = ref ? ref.frame : 'noir';
      if (frameAvail(c.id, fmt).indexOf(frame) < 0) frame = frameAvail(c.id, fmt)[0];
      state.frames.push({ uid: uidSeq++, id: c.id, fmt: fmt, frame: frame, x: 0, y: 0 });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
